import { Component } from '@angular/core';
import { LookupService } from 'src/app/services/lookup.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-newreport-period',
  templateUrl: './new-report-period.component.html',
  styleUrl: './new-report-period.component.css'
})

export class NewReportPeriodComponent {

  name = '';
  emailIds:any;
  dateperiod = '';
  submitted = false;
  reportPeriod = ""
  contingencyPath = '';
  reportData:any = [];
  faqPath = '';
  successMsg: string;
  successMessageAlert: boolean;
  failureMsg: string;
  failureMessageAlert: boolean;
  pathInfo: any;
  urlErrorFaqPath = false;
  urlErrorContPath = false;
  emailErrorCheck = false;
  requiredContPath = false;
  requiredEmail = false;
  today: string;
  errorName = false;
  errorDate: boolean;

  constructor(public lookup: LookupService, public ngxspinner:NgxSpinnerService){}

  ngOnInit(){
    const currentDate = new Date(); //Restrict date field from selecting past date
    this.today = currentDate.toISOString().split('T')[0];
    this.getReportPeriod();
  }

  getReportPeriod(){
    this.ngxspinner.show();
    this.lookup.getReportPeriod().subscribe({
      next: (res) =>{
        this.reportData = res.body.response;
        this.reportPeriod = this.reportData[0]?.unionreportperiodid;
        this.changereportPeriod(this.reportPeriod);
        this.ngxspinner.hide();
      },
      error: err =>{
        if(err) {
          this.ngxspinner.hide();
        }
      }
    })
  }

  createnewReportPeriod(){
    this.submitted = true;
    const params = {
      "name": this.name.trim(),
      "reportPeriodDate": this.dateperiod + " 00:00:00",
    }

    if((this.name && this.dateperiod) && !this.errorName && !this.errorDate) {
      this.ngxspinner.show();
      this.lookup.createReportPeriod(params).subscribe({
        next: (res) =>{
          if(res.message === "Union Report Period created successfully."){
            this.successMessageAlert = true;
            this.successMsg = res.message;
            this.name = this.dateperiod = "";
            this.submitted = false;
            this.getReportPeriod();
          }else{
            this.failureMessageAlert = true;
            this.failureMsg = res.message;
          }
          this.ngxspinner.hide();
          this.closealert()
        }, 
        error: (err) =>{
          if(err) {
            if(this.name === this.pathInfo?.name) {
              this.failureMessageAlert = true;
              this.failureMsg = "The provided name already exists. Please choose a unique name.";
            } else {
              this.failureMessageAlert = true;
              this.failureMsg = "Error in creating new report period. Please try once again";
            }
            this.ngxspinner.hide();
            this.closealert()
          }
        }
      })
    }
    setTimeout(()=>{ this.submitted = false },5000)
  }

  validateName(event) {
    const inputElement = event.target as HTMLInputElement;
    const nameRegex = /^[A-Za-z][A-Za-z0-9 ]*$/;
    const cleanName = inputElement.value
    if(nameRegex.test(cleanName)) {
      if(cleanName.length < 2 || cleanName.length > 50) {
        this.errorName = true
      } else {
        this.errorName = false
      }
      return cleanName
    }  else {
      this.errorName = true
      return inputElement.value 
    }
  }

  validateDate(event) {
    const input = event.target as HTMLInputElement;
    const selectedDate = input.value;
    if(!selectedDate) {
      this.errorDate = true
      return null
    } else {
      this.errorDate = false
      return selectedDate < this.today ? selectedDate : null
    }
  }

  newReportDatePicker(event: Event) {
    const input = event.target as HTMLInputElement;
    input.showPicker?.();
    input.focus();
  }

  updatePathDetails(){
    const pathDetails = {
      supplierunioncontingencypath : this.contingencyPath ? this.validateUrl('supplierContPath',this.contingencyPath) : '',
      faqspath: this.faqPath ? this.validateUrl('faqPath',this.faqPath) : '',
      unionreportperiodid: this.reportPeriod,
      rmadminemails: this.emailIds ? this.validateEmail(this.emailIds) : ''
    }

    if(!this.urlErrorContPath && !this.emailErrorCheck && !this.urlErrorFaqPath) {
      if(pathDetails.rmadminemails !== '' && pathDetails.supplierunioncontingencypath !== '') {
        this.ngxspinner.show();
        this.lookup.updatePathDetails(pathDetails).subscribe({
          next: (res) =>{
            if(res.body.message === "Report period info updated successfully."){
              this.successMessageAlert = true;
              this.successMsg = res.body.message;
              this.getReportPeriod();
              this.faqPath = "";
              this.contingencyPath = "";
              this.emailIds = "";
            }else{
              this.failureMessageAlert = true;
              this.failureMsg = res.body.message;
            }
            window.scrollTo(0,0);
            this.ngxspinner.hide();
            this.closealert()
          }, 
          error: err =>{
            if(err) {
              this.failureMessageAlert = true;
              this.failureMsg = "Error in updating path details. Please try once again";
              this.ngxspinner.hide();
              window.scrollTo(0,0);
              this.closealert()
            }
          }
        })
      } else {
        this.checkUpdateFields()
      }
    } else {
      this.checkUpdateFields()
    }
    setTimeout(()=>{
      this.urlErrorContPath = this.urlErrorFaqPath = this.emailErrorCheck = false;
    },5000)
  }

  checkUpdateFields() {
    if(!this.contingencyPath) {
      this.requiredContPath = true;
      this.urlErrorContPath = false;
      setTimeout(()=>{
        this.requiredContPath = false;
      },5000);
    }
    if(!this.emailIds) {
      this.requiredEmail = true;
      this.emailErrorCheck = false;
      setTimeout(()=>{
        this.requiredEmail = false;
      },5000);
    }
  }

  validateEmail(value) {
    const emailRegex = /^[\w.-]+@[\w.-]+\.\w{2,4}(,\s*[\w.-]+@[\w.-]+\.\w{2,4})*$/
    const emailIdValue = value
      .split(',')
      .map(email => email.trim())
      .join(',');
    if(emailRegex.test(emailIdValue)) {
      return emailIdValue
    } else {
      this.emailErrorCheck = true;
      this.requiredEmail = false;
      return ''
    }
  }

  validateUrl(value, urlPath) {
    const cleanUrlValue = urlPath.trim()
    const httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
    if(httpRegex.test(cleanUrlValue)) {
      return cleanUrlValue
    } else {
      if(value === 'supplierContPath') {
        this.urlErrorContPath = true;
        this.requiredContPath = false;
        setTimeout(()=>{ this.urlErrorContPath = false }, 5000)
      } else {
        this.urlErrorFaqPath = true;
        setTimeout(()=>{ this.urlErrorFaqPath = false }, 5000)
      }
      return ''
    }
  }

  changereportPeriod(reportPeriod){
    this.ngxspinner.show();
    this.lookup.getreportPeriodInfo(reportPeriod).subscribe({
      next: (data) => {
        this.ngxspinner.hide();
        if (data?.body[0]) {
          this.pathInfo = data.body[0];
          this.contingencyPath = this.pathInfo?.supplierunioncontingencypath;
          this.faqPath = this.pathInfo?.faqspath;
          this.emailIds = this.pathInfo?.rmadminemails;
        }
      },
      error: (err) => {
        if (err) {
          this.failureMessageAlert = true;
          this.failureMsg = "Error in getting path details. Please refresh once again";
          this.ngxspinner.hide();
          window.scrollTo(0, 0);
          this.closealert()
        }
      }
    }); 
  }

  onpathClick(type){
    this.failureMessageAlert = false
    if(type === 'contingency'){
      try {
        const url = this.contingencyPath.trim()
        const isTrue = this.validateUrl('supplierContPath',url)
        if(isTrue) {
          window.open(url.toString(), '_blank')
        }
      } finally { //NOSONAR
      }
    }else if(type === 'faq'){
      try {
        const url = this.faqPath.trim()
        const isTrue = this.validateUrl('faqPath',url)
        if(isTrue) {
          window.open(url.toString(), '_blank')
        }
      } finally { //NOSONAR
      }
    }else{
      this.failureMessageAlert = true;
      this.failureMsg = 'Please update the path to redirect.'
      window.scrollTo(0,0);
      this.closealert()
    }
  }

  dateChange(event){
    this.dateperiod = event.target.value;
  }

  closealert(){
    setTimeout(()=>{
      this.successMessageAlert = false;
      this.successMsg = "";
      this.failureMessageAlert = false;
      this.failureMsg = "";
    }, 10000)
  }

}
